<template>
  <div class="rbd-not-found flex-center-middle">
    <a-result title="服务未授权">
      <template #icon>
        <img
          src="../assets/images/common/not-license.png"
          alt="服务未授权，请联系管理员"
        />
      </template>
      <template #subTitle>
        <p>
          <span>抱歉，您访问的服务未授权，请联系管理员！</span>
        </p>
      </template>
      <template #extra>
        <!-- <a-button type="primary" @click="onClickToHome"> 返回首页 </a-button> -->
      </template>
    </a-result>
  </div>
</template>

<script>
export default {
  name: "NotLicense",
};
</script>

<style scoped>
.rbd-not-found {
  width: 100vw;
  height: 100vh;
}
</style>
